module.exports = __webpack_public_path__ + "img/layers-fill.4e27f6af.svg";